import React from "react";
function CasinoCoinSvgIcon({ bgColor, symbolColor, size = 16 }) {
  return /* @__PURE__ */ React.createElement("svg", { width: size, height: size, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React.createElement("rect", { width: "16", height: "16", rx: "8", fill: bgColor }), /* @__PURE__ */ React.createElement("path", { d: "M4.11111 11.5L3 5.08333L6.05556 8L8 4.5L9.94444 8L13 5.08333L11.8889 11.5H4.11111Z", fill: symbolColor }));
}
export {
  CasinoCoinSvgIcon
};
//# sourceMappingURL=CasinoCoinSvgIcon.js.map
